import React from 'react';
import { makeStyles, MenuItem } from '@material-ui/core';
import Modal from 'src/component/Modal/Modal';
import { CStandardInput } from '../../../../../../component/Input';
import { DefaultSelect } from '../../../../../../component/Select';
import CButton from '../../../../../../component/Button';

const useStyles = makeStyles({
  coordsWrapperDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    justifyContent: 'space-between'
  },
  phoneWrapper: {
    alignItems: 'center',
    display: 'flex'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  },
  wrapperDiv: {
    display: 'flex',
    flexDirection: 'column',
    height: '450px',
    justifyContent: 'space-evenly'
  }
});

const AddressesEditModal = (props) => {
  const { address, open, onUpdate, onClose, setSelectedAddress } = props;
  const classes = useStyles();
  const cites = ['Tbilisi', 'Batumi', 'Gori', 'Kutaisi'];

  return (
    <div>
      <Modal
        footerActions={
          <>
            <CButton htmlType="submit" onClick={onClose} size="large" type="secondary">
              Cancel
            </CButton>
            <CButton
              htmlType="submit"
              onClick={() => {
                onUpdate();
                onClose();
              }}
              size="large"
              type="primary"
              // disabled={!isSaveEnabled}
            >
              Save
            </CButton>
          </>
        }
        handleClose={onClose}
        isModalOpen={open}
        styles={{
          width: '400px'
        }}
        titleContent={<span className="modal-title">Edit Address</span>}
      >
        <div className={classes.wrapperDiv}>
          <CStandardInput
            defaultValue={address.name}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-customer-address-edit-name"
            id="standard-customer-address-edit-name"
            label="FullName"
            onChange={(event) => {
              setSelectedAddress({ ...address, name: event.target.value });
            }}
            size="large"
          />
          <DefaultSelect
            defaultValue={address.city || 'Tbilisi'}
            onSelect={(value) => {
              setSelectedAddress({ ...address, city: value });
            }}
            renderValue={(value) => value}
            selectStyles={{ marginTop: '16px' }}
          >
            {cites.map((city) => (
              <MenuItem key={city} defaultValue={city}>
                {city}
              </MenuItem>
            ))}
          </DefaultSelect>
          <CStandardInput
            defaultValue={address.street}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-customer-address-edit-street"
            id="standard-customer-address-edit-street"
            label="Address"
            onChange={(event) => {
              setSelectedAddress({ ...address, street: event.target.value });
            }}
            size="large"
          />
          <CStandardInput
            defaultValue={address.apartment}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-customer-address-edit-apartment"
            id="standard-customer-address-edit-apartment"
            label="Apartment/Floor"
            onChange={(event) => {
              setSelectedAddress({ ...address, apartment: event.target.value });
            }}
            size="large"
          />
          <CStandardInput
            defaultValue={`${address?.phone_number?.country_code} ${address?.phone_number?.number}`}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-customer-address-edit-phone"
            id="standard-customer-address-edit-phone"
            label="Phone Number"
            onChange={(event) => {
              // split phone number to country code and number
              const [countryCode, number] = event.target.value.split(' ');

              setSelectedAddress({
                ...address,
                phone_number: {
                  country_code: countryCode,
                  number,
                  selected_country: 'GE'
                }
              });
            }}
            size="large"
          />
          <div className={classes.coordsWrapperDiv}>
            <CStandardInput
              defaultValue={address.coords?.lat}
              disableUnderline
              formclasses={{ root: classes.root }}
              htmlFor="standard-customer-coords-lang"
              id="standard-customer-coords-lang"
              label="Latitude"
              onChange={(event) => {
                setSelectedAddress({ ...address, lat: event.target.value });
              }}
              size="large"
            />
            <CStandardInput
              defaultValue={address.coords?.lng}
              disableUnderline
              formclasses={{ root: classes.root }}
              htmlFor="standard-customer-address-edit-comment"
              id="standard-customer-address-edit-comment"
              label="Longitude"
              onChange={(event) => {
                setSelectedAddress({ ...address, lng: event.target.value });
              }}
              size="large"
            />
          </div>
          <CStandardInput
            defaultValue={address.comment}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-customer-address-edit-comment"
            id="standard-customer-address-edit-comment"
            label="Comment"
            onChange={(event) => {
              setSelectedAddress({ ...address, comment: event.target.value });
            }}
            size="large"
          />
        </div>
      </Modal>
    </div>
  );
};

export default AddressesEditModal;
